export const main = {
  uz: {
    homeTopTitle: `Biz uchun baxt – sizning <br/> ko’zaringizdagi <br/> quvonch`,
    homeTopText:
      "Ko’z kasalliklarini davolashda <br/> <b>professionallar</b> jamoasi, <br/> <b>Choriqul Shaymatov Gavhari</b> <br/> klinikasiga xush kelibsiz.",
    homeTopBtn: "Konsultatsiya olish",
    homeAboutUsTitle: "Ko'z klinikasi",
    homeAboutUsSubTitle: "“CHORIQUL SHAYMATOV GAVHARI”",
    homeAboutUsText:
      "Bizning klinikamiz turli ko’z kasalliklari bilan murojat qilgan bemorlarga, quyidagi omillarni: malakali tajribaga ega oftalmolog-shifokorlar maslahati, zamonaviy yuqori texnologiyali uskunalar va xalqaro tibbiyot standartlariga mos keluvchi davolashni uyg‘unlashtirgan, tibbiy yordamni taqdim etadi. Bu bemorlarimizga aniq tashxis qo’yish, samarali davolashni bajarish va albatta ko‘rish qobiliyatini yaxshilanishini kafolatlaydi",
    homeAboutUsBtn: "Klinika Haqida",
    homeAdvantagesTitle: "Kelajak texnologiyasi – ko’zlaringiz sog’ligi uchun",
    homeAdvantagesLaserCorrection: "Lazerli ko'z korrektsiyasi",
    homeAdvantagesCataract: "Katarakta jarrohligi",
    homeAdvantagesSurgery: "Vitreoretinal jarrohligi",
  },
  ru: {
    homeTopTitle: `Наше счастье - видеть <br/> радость <br/> в ваших глазах`,
    homeTopText:
      "Добро пожаловать клинику <br/> <b>Choriqul Shaymatov Gavhari</b>, <br/> где профессионалы <br/> заботятся о ваших глазах",
    homeTopBtn: "Получить консультацию",
    homeAboutUsTitle: "Глазная клиника",
    homeAboutUsSubTitle: "“CHORIQUL SHAYMATOV GAVHARI”",
    homeAboutUsText: "Наша клиника предоставляет медицинскую помощь мирового уровня пациентам с различными офтальмологическими заболеваниями благодаря гармоничному сочетанию таких факторов, как высокий профессионализм врачей-офтальмологов, оснащение передовым высокотехнологичным оборудованием и строгое соблюдение международных стандартов оказания медицинской помощи. Всё это обеспечивает высокую точность диагностики, эффективность лечения и максимально возможное восстановление зрительных функций у пациентов.",
    homeAboutUsBtn: "О клинике",
    homeAdvantagesTitle: "Технологии будущего - для здоровья ваших глаз",
    homeAdvantagesLaserCorrection: "Лазерная коррекция зрения",
    homeAdvantagesCataract: "Хирургия катаракты",
    homeAdvantagesSurgery: "Витреоретинальная хирургия",
  },
  tj: {
    homeTopTitle: `Ҷаҳон дар чашмони дурахшони шумост`,
    homeTopText:
      "Хуш омадед ба клиникаи чашм <br/> <b>Choriqul Shaymatov Gavhari,</b> <br/> дар куҷо мутахассисон ба чашмони шумо ғамхорӣ мекунанд",
    homeTopBtn: "Машварат гиред",
    homeAboutUsTitle: "Клиникаи чашм",
    homeAboutUsSubTitle: "CHORIQUL SHAYMATOV GAVHARI",
    homeAboutUsText:
      "Инҳо кормандони ботаҷриба ва баландихтисос, таҷҳизоти баландтехнологӣ, риояи қатъии стандартҳои тибби муосир барои расонидани ерии тиббии сатҳи ҷаҳонӣ мебошанд",
    homeAboutUsBtn: "Дар бораи клиника",
    homeAdvantagesTitle: "Манфиатҳои мо",
    homeAdvantagesLaserCorrection: "Лазерная коррекция зрения",
    homeAdvantagesCataract: "Хирургия катаракты",
    homeAdvantagesSurgery: "Витреоретинальная хирургия",
  },
};
